import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import Badge from "@mui/material/Badge";
import Avatar from "@mui/material/Avatar";
import StarSvg from "../../Svg/StarSvg";
import { getDataFromStorage } from "../../util";
import RankFirstSvg from "../../Svg/RankFirstSvg";
import RankSecondSvg from "../../Svg/RankSecondSvg";
import RankThirdSvg from "../../Svg/RankThirdSvg";
import CircularProgress from "@mui/material/CircularProgress";
import moment from "moment-timezone";
import useAuth from "../../Hooks/useAuth";
import useAxiosPrivate from "../../Hooks/useAxiosPrivate";
import { RESULT_STATUS } from "../../constants";
import useS3FileManagement from "../../Hooks/useS3FileManagement";
export default function Leaderboard() {
  const {
    loadingLeaderboard,
    setLoadingLeaderboard,
    setIsLoaded,
    setShowNotify,
  } = useAuth();
  const axios = useAxiosPrivate();
  const { getPreSignedUrl } = useS3FileManagement();
  const [leaderboardData, setLeaderboardData] = useState([]);
  const [cachedTime, setCachedTime] = useState(null);
  const [error, setError] = useState(null);

  console.log(
    "cachedTime",
    moment(cachedTime).tz("Asia/Kolkata").format("YYYY-MM-DD HH:mm:ss")
  );
  const batchId = localStorage.getItem("batchid");
  useEffect(() => {
    const handleLeaderBoard = async (refresh = false) => {
      setLoadingLeaderboard(true);
      try {
        const { data } = await axios.get(
          `node/learner/${getDataFromStorage(
            "learnerid"
          )}/batch/${batchId}/leaderboard?refresh=${refresh}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (data.resultCode === RESULT_STATUS.NO_DATA) {
          console.log("No leaderboard data available");
          setLeaderboardData([]);
        } else {
          if (data.resultCode === RESULT_STATUS.SUCCESS) {
            console.log("Leaderboard data fetched successfully", data.data.data);
            const leaders = data.data.data || [];
            const pictureKeys = leaders
              .map((student) => student?.picture)
              .filter(Boolean);

            let leaderboardWithPictures = leaders;
            if (pictureKeys.length > 0) {
              const presignedResponse = await getPreSignedUrl(
                pictureKeys,
                undefined,
                "",
                "GET"
              );
              const presignedUrls = presignedResponse?.url || [];
              const urlByPictureKey = pictureKeys.reduce((acc, key, index) => {
                acc[key] = presignedUrls[index];
                return acc;
              }, {});

              leaderboardWithPictures = leaders.map((student) => ({
                ...student,
                picture: urlByPictureKey[student?.picture] || student?.picture,
              }));
            }

            setLeaderboardData(leaderboardWithPictures);
            setCachedTime(
              moment(data.createdAt)
                .tz("Asia/Kolkata")
                .format("YYYY-MM-DD HH:mm:ss")
            );
            setLoadingLeaderboard(false);
          }
        }
      } catch (error) {
        if (error.message.includes("403")) {
          setShowNotify({
            show: true,
            title: "Warning !",
            isUnAuth: true,
            msg: "You have been logged-out due to inactivity. Login again.",
          });
          return;
        }
        setError("Unable to fetch the leaderboard");
        setLeaderboardData([]);
      } finally {
        setLoadingLeaderboard(false);
        setIsLoaded(false);
      }
    };
    handleLeaderBoard();
  }, [
    setLoadingLeaderboard,
    axios,
    setIsLoaded,
    setShowNotify,
    batchId,
  ]);

  /* sorting by rank */
  let sortedData = leaderboardData?.sort((a, b) => a.ranking - b.ranking);
  console.log("sortedData", sortedData);
  let currentUserId = getDataFromStorage("learnerid");
  /* get top 3 students */
  let top3Students = sortedData?.slice(0, 3);
  /* get 10 students for table */
  let remainingStudents = sortedData?.slice(3, 13);
  /* check current user is in top3 or remaing 10 */
  const isCurrentUserInTop3 = top3Students?.some(
    (student) => student.id == currentUserId
  );
  const isCurrentUserInTable = remainingStudents?.some(
    (student) => student.id == currentUserId
  );

  if (isCurrentUserInTop3) {
    remainingStudents = sortedData?.slice(3, 13);
  } else if (isCurrentUserInTable) {
    remainingStudents = sortedData?.slice(3, 13);
  } else {
    let findPosition = sortedData?.findIndex((data) => {
      return data.id == currentUserId;
    });
    let current = sortedData[findPosition];
    remainingStudents.splice(9, 1, current);
  }

  /* capitalize first letter */
  function capitalizeFirstLetter(str) {
    if (str) return str[0].toUpperCase() + str.slice(1);
  }

  return (
    <Box className="leaderboard-box-div">
      <Box className="leaderboard-box-header-sec">
        <Box className="leaderboard-box-header-left-sec">
          <Typography className="leaderboard-box-header" gutterBottom>
            Leaderboard
          </Typography>
          {cachedTime && !loadingLeaderboard ? (
            <Typography className="leaderboard-box-header-cached-time">
              Updated at {cachedTime}
            </Typography>
          ) : null}
        </Box>
        {/* <Tooltip title="Refresh" isIcon={true}>
          <IconButton
            hierarchy="tertiaryGrey"
            onClick={() => handleLeaderBoard(true)}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.6665 8.33333C1.6665 8.33333 3.33732 6.05685 4.6947 4.69854C6.05208 3.34022 7.92783 2.5 9.99984 2.5C14.142 2.5 17.4998 5.85786 17.4998 10C17.4998 14.1421 14.142 17.5 9.99984 17.5C6.58059 17.5 3.69576 15.2119 2.79298 12.0833M1.6665 8.33333V3.33333M1.6665 8.33333H6.6665"
                stroke="#667085"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </IconButton>
        </Tooltip> */}
      </Box>
      {loadingLeaderboard ? (
        <Box
          style={{ height: "50px", display: "flex", justifyContent: "center" }}
        >
          <CircularProgress style={{ color: "#F55533" }} />
        </Box>
      ) : !leaderboardData.length ? (
        <Box className="leaderboard-empty-data-box">
          {error ? error : "No Leaderboard Data"}
        </Box>
      ) : (
        <>
          <Box className="leaderboard-paper-table">
            <Box className="leaderboard-table-topranker-box">
              <Card className="leaderboard-firstrank">
                <Badge
                  className="leaderboard-firstrank-avatar-badge"
                  overlap="circular"
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  badgeContent={<RankFirstSvg />}
                >
                  <Avatar
                    className="leaderboard-firstrank-avatar"
                    alt={capitalizeFirstLetter(top3Students[0]?.name)}
                    src={top3Students[0]?.picture}
                  />
                </Badge>
                <Typography className="leaderboard-firstrank-learnername">
                  {capitalizeFirstLetter(top3Students[0]?.name)}
                </Typography>
                <Typography className="leaderboard-firstrank-pointsearned">
                  <span>
                    <StarSvg
                      className="leaderboard-table-head-starsvg"
                      height={"16"}
                      width={"16"}
                    />
                    {top3Students[0]?.totalPointsEarned}
                    {
                      // top3Students[0]?.id === getDataFromStorage("learnerid") && <ArrowSvg className='currentlearner-top3card-svg' height={"10"} width={"10"} pathfill={"#FD710B"} handleFunction={props.handleLeaderboardDetail} />
                    }
                  </span>
                </Typography>
              </Card>
              <Card className="leaderboard-secondrank">
                <Badge
                  className="leaderboard-secondrank-avatar-badge"
                  overlap="circular"
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  badgeContent={
                    top3Students[1]?.ranking === 1 ? (
                      <RankFirstSvg />
                    ) : top3Students[1]?.ranking === 3 ? (
                      <RankThirdSvg />
                    ) : (
                      <RankSecondSvg />
                    )
                  }
                >
                  <Avatar
                    className="leaderboard-secondrank-avatar"
                    alt={capitalizeFirstLetter(top3Students[1]?.name)}
                    src={top3Students[1]?.picture}
                  />
                </Badge>
                <Typography className="leaderboard-secondrank-learnername">
                  {capitalizeFirstLetter(top3Students[1]?.name)}
                </Typography>
                <Typography className="leaderboard-secondrank-pointsearned">
                  <span>
                    <StarSvg
                      className="leaderboard-table-head-starsvg"
                      height={"16"}
                      width={"16"}
                    />
                    {top3Students[1]?.totalPointsEarned}
                    {/* {top3Students[1]?.id === getDataFromStorage("learnerid") && <ArrowSvg className='currentlearner-top3card-svg' height={"10"} width={"10"} pathfill={"#FD710B"} handleFunction={props.handleLeaderboardDetail} />} */}
                  </span>
                </Typography>
              </Card>
              <Card className="leaderboard-thirdrank">
                <Badge
                  className="leaderboard-thirdrank-avatar-badge"
                  overlap="circular"
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  badgeContent={
                    top3Students[2]?.ranking === 1 ? (
                      <RankFirstSvg />
                    ) : top3Students[2]?.ranking === 2 ? (
                      <RankSecondSvg />
                    ) : (
                      <RankThirdSvg />
                    )
                  }
                >
                  <Avatar
                    className="leaderboard-thirdrank-avatar"
                    alt={capitalizeFirstLetter(top3Students[2]?.name)}
                    src={top3Students[2]?.picture}
                  />
                </Badge>
                <Typography className="leaderboard-thirdrank-learnername">
                  {capitalizeFirstLetter(top3Students[2]?.name)}
                </Typography>
                <Typography className="leaderboard-thirdrank-pointsearned">
                  <span>
                    <StarSvg
                      className="leaderboard-table-head-starsvg"
                      height={"16"}
                      width={"16"}
                    />
                    {top3Students[2]?.totalPointsEarned}
                    {/* {top3Students[2]?.id === getDataFromStorage("learnerid") && <ArrowSvg className='currentlearner-top3card-svg' height={"10"} width={"10"} pathfill={"#FD710B"} handleFunction={props.handleLeaderboardDetail} />} */}
                  </span>
                </Typography>
              </Card>
            </Box>

            <TableContainer
              className="leaderboard-table-container"
              component={Paper}
            >
              <Table className="leaderboard-table" stickyHeader>
                <TableHead className="leaderboard-table-head">
                  <TableRow className="leaderboard-table-head-row">
                    <TableCell className="leaderboard-table-head-ranktablecell">
                      Rank
                    </TableCell>
                    <TableCell className="leaderboard-table-head-nametablecell">
                      Name
                    </TableCell>
                    <TableCell className="leaderboard-table-head-pointstablecell">
                      Points
                      <StarSvg
                        className="leaderboard-table-head-starsvg"
                        height={"12px"}
                        width={"12px"}
                      />
                    </TableCell>
                    {/* Add more columns as needed */}
                  </TableRow>
                </TableHead>
                <TableBody className="leaderboard-table-body">
                  {remainingStudents.length > 0 &&
                    remainingStudents?.map((member, index) => (
                      <TableRow
                        className={
                          member?.id == getDataFromStorage("learnerid")
                            ? "leaderboard-table-body-row-currentlearner"
                            : "leaderboard-table-body-row"
                        }
                        key={member?.id}
                      >
                        <TableCell className="leaderboard-table-body-row-ranktablecell">
                          {member?.ranking}
                        </TableCell>
                        <TableCell className="leaderboard-table-body-row-nametablecell">
                          {capitalizeFirstLetter(member?.name)}
                          {member?.id == getDataFromStorage("learnerid") && (
                            <span className="current-learner">
                              {getDataFromStorage("role") === "parent"
                                ? ""
                                : "(You)"}
                            </span>
                          )}
                        </TableCell>
                        <TableCell className="leaderboard-table-body-row-pointstablecell">
                          {member?.totalPointsEarned}
                          {/* {member?.id === getDataFromStorage("learnerid") && (getDataFromStorage("role")==="learner"&&<ArrowSvg handleFunction={props.handleLeaderboardDetail}/>)} */}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </>
      )}
    </Box>
  );
}
